/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React, { PropsWithChildren } from 'react';

// ours
import BackButton from '../back-button/BackButton';
import BasicDrawer from 'src/bw/bw-drawer/common/BasicDrawer';
import Disclosures from 'src/bw/bw-drawer/disclosures/Disclosures';
import Typography from '../typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

// styles
import styles from './Drawer.module.scss';
import useDocumentTitle from 'src/hooks/useDocumentTitle';

interface DrawerProps {
    withBackButton?: boolean;
    drawerProps?: any;
    handleBack?: () => void;
    header?: JSX.Element;
    title?: string;
    disclosures?: JSX.Element;
    withoutStickyHeader?: boolean;
    className?: string;
    'data-cy'?: string;
}

export default function Drawer({
    withBackButton,
    drawerProps,
    handleBack,
    header,
    title,
    disclosures = <Disclosures />,
    withoutStickyHeader = false,
    className,
    children,
    ...props
}: PropsWithChildren<DrawerProps>): JSX.Element {
    useDocumentTitle(title);

    return (
        <BasicDrawer>
            <div className="bw-drawer bw-main-drawer" {...props}>
                <div className={[styles.genericDrawer, className].join(' ')}>
                    {!withoutStickyHeader && (
                        <div className={styles.stickyHeader}>
                            {withBackButton && <BackButton drawerProps={drawerProps} handleBack={handleBack} />}
                            {header || (
                                <Typography
                                    component="h1"
                                    variant={TypographyVariants.HEADING_S}
                                    className={styles.drawerTitle}
                                >
                                    {title}
                                </Typography>
                            )}
                        </div>
                    )}
                    <div className={styles.drawerContent}>
                        {children}
                        {disclosures}
                    </div>
                </div>
            </div>
        </BasicDrawer>
    );
}
